/**
 * Error message strings
 */

export const ERROR_HEADING__500 = 'Oops!';
export const ERROR_HEADING__204 = 'No data available.';

export const ERROR_MESSAGE__204 = 'No data available.';
export const ERROR_MESSAGE__500 = 'There was a problem communicating with the server. '
+ 'Please ensure that you are online and try again.';

export const ERROR_MESSAGE_WEATHER__204 = 'No weather information currently available for this loaction.';
export const ERROR_MESSAGE_WEATHER__500 = 'There was a problem communicating with the server. '
+ 'Please ensure that you are online and try again.';
export const ERROR_MESSAGE_WEATHER_DATA_ERROR__500 = 'There was a problem loading some weather data.';
export const ERROR_MESSAGE_WEATHER_MODULE__204 = 'No weather data available.';
export const ERROR_MESSAGE_WEATHER_MODULE__500 = 'Can\'t load module';

export const ERROR_MESSAGE_WEATHER_SUMMARY__204 = ERROR_MESSAGE_WEATHER_MODULE__204;
export const ERROR_MESSAGE_WEATHER_CURRENT_CONDITIONS__204 = 'No current conditions available.';
export const ERROR_MESSAGE_WEATHER_OUTLOOK__204 = 'No forecast data available.';
export const ERROR_MESSAGE_WEATHER_MOON_PHASES__204 = 'No moon phase data available.';

export const ERROR_MESSAGE_DETAILS_PAGE__500 = 'There was a problem retrieving the details.';
export const ERROR_MESSAGE_DETAILS_PAGE__500_ALERT = 'There was a problem retrieving this alert.';
export const ERROR_MESSAGE_DETAILS_PAGE_EXPIRED = 'This data has expired.';
export const ERROR_MESSAGE_DETAILS_PAGE__ALERT_EXPIRED = 'This alert has expired.';
export const ERROR_MESSAGE_DETAILS_PAGE__WEATHER_WARNING_EXPIRED = 'This weather warning has expired.';

export const ERROR_MESSAGE_WEATHER_GRAPHS__204 = (chartType) => {
  if (!chartType) return ERROR_MESSAGE_WEATHER_MODULE__204;

  return `No ${chartType} data available.`;
};

export const WEATHER_INCOMPLETE_DATA_MESSAGE = 'Some weather conditions are currently unavailable for this location.';
export const WEATHER_WARNINGS_NO_CURRENT_WARNINGS_MESSAGE = 'No weather warnings in your area.';
